import {ReactComponent as LogoLobsterkaVertical} from '../../gfx/logo-lobsterka-vertical.svg'
import {Spin} from 'antd'

export default function WelcomeCurtain({active}) {
  return (
    <div className={`welcome-curtain ${active ? 'active' : ''}`}>
      <LogoLobsterkaVertical />
      <br/>
      <Spin size="large"/>
    </div>
  )
}